import OrderDetail from '@/components/OrdersModule/OrderDetail/OrderDetail'
import { useClearNonexistentSelectedOrder } from '@/features/orders/hooks/useClearNonexistentSelectedOrder'
import { useAppSelector } from '@/hooks/redux'
import { ordersSelectors } from '@/redux/reducers/orders/selectors'
import { FC } from 'react'
import { StyleSheet } from 'react-native'
import Animated, { FadeIn, FadeOut } from 'react-native-reanimated'

const ExtendedOrderDetailContainer: FC = () => {
    const selectedOrderUuid = useAppSelector(ordersSelectors.selectedOrderUuid)

    useClearNonexistentSelectedOrder(selectedOrderUuid ?? '')

    if (!selectedOrderUuid) {
        return null
    }

    return (
        <Animated.View
            key={selectedOrderUuid}
            entering={FadeIn.duration(125)}
            exiting={FadeOut.duration(125)}
            style={styles.container}
        >
            <OrderDetail uuid={selectedOrderUuid} />
        </Animated.View>
    )
}

const styles = StyleSheet.create({
    container: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        width: '50%',
        zIndex: 1,
    },
})

export default ExtendedOrderDetailContainer
